import { GetModelerTestCasesRequest } from '@eggplant/api-requests'
import { LinkToAddTestCase } from '@eggplant/routing'
import {
  Paragraph,
  SingleSelect
} from '@eggplant/pattern-library'
import type {
  GetTestCasesParams,
  GetTestCasesResponse,
  Options
} from '@eggplant/types'

interface Props {
  initialOptions?: Options
  modelId?: string
  prompt?: string
  onChange: (value: string) => void
  onSuccess?: (data: GetTestCasesResponse) => void
  value: string
  isRequired?: boolean
  isDisabled?: boolean
}

const getOptions = (data: GetTestCasesResponse) =>
  data.items
    .filter(item =>
      !!item.id
    )
    .map(item => ({
      label: item.name,
      value: item.id
    }))

const SelectModelerTestCase = ({
  initialOptions = [],
  modelId,
  prompt = 'Select a test case',
  onChange,
  onSuccess,
  value,
  isRequired,
  isDisabled = false
}: Props) => {
  const params: GetTestCasesParams = {
    model_id: modelId,
    sort: '+name'
  }

  const handleChange = (value: string) => {
    onChange(value)
  }

  return (
    <GetModelerTestCasesRequest
      onSuccess={onSuccess}
      params={params}
    >
      {
        (data: GetTestCasesResponse) => data.total_count
          ? (
            <SingleSelect
              isDisabled={isDisabled}
              isRequired={isRequired}
              label='Select a test case'
              onChange={handleChange}
              options={
                [
                  ...initialOptions,
                  ...getOptions(data)
                ]
              }
              prompt={prompt}
              value={value}
            />
          )
          : (
            <Paragraph>
              <LinkToAddTestCase
                model_id={modelId}
              >
                Create
              </LinkToAddTestCase>
              &nbsp;a test case
            </Paragraph>
          )
      }
    </GetModelerTestCasesRequest>
  )
}

export default SelectModelerTestCase
